import React from "react";
import * as S from "./style";

interface Props {
  percent: number;
  isShining?: boolean;
}

function ProgressBar({ percent, isShining }: Props): React.ReactElement {
  const overFlag =
    typeof percent === "number" ? Math.floor(percent / 100) * 100 : 0;

  return (
    <S.ProgressBar percent={percent} isShining={isShining}>
      <style>
        {`
          @keyframes shine {
            0% {
              transform: translateX(-100%);
              opacity: 0.5;
            }
            50% {
              opacity: 0.8;
            }
            100% {
              transform: translateX(100%);
              opacity: 0.5;
            }
          }
        `}
      </style>
      <div className="container">
        <div className="progress-bar">
          <div
            className="progress-bar-inner"
            style={{
              width: `${
                typeof percent === "number"
                  ? percent > 100
                    ? 100
                    : percent
                  : 0
              }%`,
              background:
                percent && percent > 100
                  ? overFlag === 100
                    ? `linear-gradient(90deg,#653CD5 ${
                        overFlag - (percent - overFlag)
                      }%,#F80593 ${overFlag}%)`
                    : "#F80593"
                  : "#653CD5",
            }}
          />
          {isShining && percent > 100 && <div className="shine-effect" />}
        </div>
      </div>
    </S.ProgressBar>
  );
}

export default ProgressBar;
